(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kdh-load-more"] && !Shopify.designMode) return;
  try {
    class KdhLoadMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.kdh-load-more__button');
      if (!this.button) return;
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.load();
      });
    }

    async load() {
      const grid = document.querySelector('.product-grid');
      if (!grid) {
        window.location.href = this.button.href;
        return;
      }

      const url = new URL(this.button.href, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);

      const label = this.button.textContent;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = 'Lädt …';

      try {
        const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const items = doc.querySelectorAll('.product-grid > li');
        const firstNew = items[0];
        for (const item of items) {
          grid.appendChild(document.importNode(item, true));
        }

        const next = doc.querySelector('kdh-load-more, .kdh-load-more--done');
        if (next) {
          this.replaceWith(document.importNode(next, true));
        } else {
          this.remove();
        }

        if (firstNew) {
          const appended = grid.querySelector(`#${CSS.escape(firstNew.id)}`);
          appended?.querySelector('a')?.focus({ preventScroll: true });
        }
      } catch (error) {
        this.button.removeAttribute('aria-busy');
        this.button.textContent = label;
        window.location.href = this.button.href;
      }
    }
  }

  if (!customElements.get('kdh-load-more')) {
    customElements.define('kdh-load-more', KdhLoadMore);
  }
  } catch(e) { console.error(e); }
})();

})();
